<form novalidate role="form" [formGroup]="form" autocomplete='off'>
    <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="labelButtons">Upload Documents</h4>
    </div>
    <div class="modal-body">
        <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
        <p-table styleClass="mvd_table--requirements" [value]="requiredDocumentDetails" *ngIf="requiredDocumentDetails && requiredDocumentDetails.length > 0">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="4">
                        No Records Found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="w--actions text-center">Status</th>
                    <th>Document Category</th>
                    <th>Document Type</th>
                    <th>Privacy Level</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [pSelectableRow]="data">
                    <td>
                        <div class="text-center" *ngIf="data.requirementSatisfied == true"><i class="material-icons status--satisfied">check_circle</i></div>
                        <div class="text-center" *ngIf="data.requirementSatisfied == false"><i class="material-icons status--unsatisfied">error</i></div>
                    </td>
                    <td>{{ data.documentCategoryTypeDisplayValue }}</td>
                    <td>{{ data.documentTypeDisplayValue }}</td>
                    <td>{{ data.accessControlTypeDisplayValue }}</td>
                </tr>
            </ng-template>
        </p-table>
        <ng-container *ngIf="data.isDocumentUploadEnabled">
            <button class="icon--scan btn--default" type="button" (click)="scanDocuments()">Scan to Upload</button>
            <p-fileUpload #fileInput name="myfile[]" [url]="fileUploadPath" chooseLabel="Upload Files" [showUploadButton]="false" [showCancelButton]="false" (onSelect)="onFileSelected($event)" multiple="multiple" accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF,.docx,.xlsx,.zip">
                <ng-template let-file pTemplate="file">
                </ng-template>
                <ng-template pTemplate="content">
                    <div class="drag-drop-zone text-center mvd_table--container hidden--md-down">
                        <div class="col-sm-8">
                            <p *ngIf="!uploadError"><i class="material-icons">file_upload</i><br />Drag Files (PDF, JPEG, PNG, DOCX, XLSX, ZIP)</p>
                            <p *ngIf="uploadError"><i class="material-icons" style="color:orangered">clear</i><br />Something went wrong. Please make sure you have the correct file type and are under the maximum file size.</p>
                        </div>
                    </div>
                </ng-template>
            </p-fileUpload>
        </ng-container>
        <ng-container *ngIf="documents.length > 0" formArrayName="documents">
            <ng-container *ngFor="let d of documents.controls; let i = index" [formGroup]="d">
                <h2>
                    File to Upload
                    <button *ngIf="data.isRemoveDocumentEnabled" class="icon--remove btn--default" type="button" (click)="removeDocument(i)">Remove</button>
                </h2>
                <fieldset>
                    <div class="row">
                        <div class="col-sm-8 col-md-9  mvd_form-group">
                            <label>File Name</label>
                            <div class="mvd_form-control" *ngIf="!data.isDocumentNameEditable">
                                <b>{{ d.get('documentFileName').value }}</b>
                            </div>
                            <input class="mvd_form-control" type="text" pInputText *ngIf="data.isDocumentNameEditable" formControlName="documentFileName" />
                        </div>
                        <div class="col-sm-4 col-md-3 mvd_form-group">
                            <label>Review Status</label>
                            <p-dropdown [options]="documentReviewStatusTypes" formControlName="documentReviewStatusTypeId"></p-dropdown>
                            <control-validation-messages control="documentReviewStatusTypeId"></control-validation-messages>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-9 mvd_form-group">
                            <label>File Description</label>
                            <textarea class="mvd_form-control" rows="3" formControlName="documentDescription"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2 mvd_form-group">
                            <label>Signature Required</label>
                            <input class="mvd_form-control" type="checkbox" formControlName="signatureRequired">
                        </div>
                        <div class="col-sm-9 col-lg-10  mvd_form-group">
                            <label>Signature Email/Notification Comment</label>
                            <textarea class="mvd_form-control" rows="3" formControlName="signatureComment"></textarea>
                        </div>
                    </div>
                    <ng-container formArrayName="documentRequirements">
                        <div class="row" *ngFor="let r of d.get('documentRequirements').controls; let ri = index" [formGroup]="r">
                            <div class="col-sm-6 col-md-4  mvd_form-group">
                                <label class="required" title="* Required">Document Category</label>
                                <p-dropdown styleClass="data-category" [options]="documentCategoryTypes" formControlName="documentCategoryTypeId" placeholder="Select" filter="true"></p-dropdown>
                                <control-validation-messages control="documentCategoryTypeId"></control-validation-messages>
                            </div>
                            <div class="col-sm-6 col-md-4  mvd_form-group">
                                <label class="required" title="* Required">Document Type</label>
                                <p-dropdown styleClass="data-type" [options]="documentTypes[r.get('documentCategoryTypeId').value]" formControlName="documentTypeId" placeholder="Select" filter="true"></p-dropdown>
                                <control-validation-messages control="documentTypeId"></control-validation-messages>
                            </div>
                            <div class="col-sm-5 col-md-3  mvd_form-group">
                                <label class="required" title="* Required">Privacy Level</label>
                                <p-dropdown styleClass="data-type" [options]="documentPrivacyLevels" formControlName="documentAccessControlTypeId" placeholder="Select"></p-dropdown>
                            </div>
                            <div class="col-sm-1  mvd_form-group" *ngIf="!requirementRequired(r)">
                                <label>&nbsp;</label>
                                <a class="icon--remove" title="Remove" href="javascript:void(0);" (click)="removeDocumentRequirement(d, ri)"></a>
                            </div>
                        </div>
                    </ng-container>
                    <div class="row">
                        <div class="col-sm-12 mvd_form-group">
                            <a class="icon--add" href="javascript:void(0)" (click)="addDocumentRequirement(d)" *ngIf="data.isAddRequirementEnabled"> Add Category/Type</a>
                        </div>
                    </div>
                </fieldset>
            </ng-container>
        </ng-container>
    </div>
    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--default" type="button" data-bs-dismiss="modal" (click)="close()">Close</button>
            <button class="btn--primary" type="button" (click)="upload()" [disabled]="form.invalid || isBusy">Upload</button>
        </div>
    </div>
</form>